import MultiSelectPanel from 'components/MultiSelectPanel';

import useBoundaryPanelItems from 'hooks/useBoundaryPanelItems';
import useBoundarySections from 'hooks/useBoundarySections';

import useTranslation from './hooks/useTranslation';

import { ENTITY_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

// Toggling is forwarded to the consumer rather than resolved here: selecting a boundary that
// belongs to another field has to be confirmed before the selection is allowed to change.
const BoundaryMultiSelectPanelField: FunctionComponent<Props> = ({
    className = '',
    excludedValues,
    onToggle,
    siteId,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { getSectionKey, sections } = useBoundarySections({ siteId });
    const { handleAsyncFilter, hasNextPage, isLoading, items, noItemsText, onNextPage } =
        useBoundaryPanelItems({ excludedValues, siteId });

    return (
        <MultiSelectPanel
            className={className}
            entityType={ENTITY_TYPE}
            getSectionKey={getSectionKey}
            hasNextPage={hasNextPage}
            isLoading={isLoading}
            items={items}
            itemsSelected={value}
            label={SEARCH}
            noItemsFoundText={noItemsText}
            onFilter={handleAsyncFilter}
            onNextPage={onNextPage}
            onToggle={onToggle}
            sections={sections}
            testId={testId}
        />
    );
};

export default BoundaryMultiSelectPanelField;
